export default __webpack_public_path__ + "static/media/myVoice.324f9559.png";